import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { User } from './../models/user';
import { ChatMessage } from './../models/ia';
import { StorageService } from './storage.service'
import { AlertController } from '@ionic/angular';
import { NetworkService } from './network.service';
import { UserService } from './user.service';
import { DateUtilsService } from './date-utils.service';
import { IndexedDbService } from './indexed-db.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class IaService {
  chatMessages: ChatMessage[] = [];

  constructor(
    private http: HttpClient,
    public storageService: StorageService,
    public networkService: NetworkService,
    private translate: TranslateService,
    private dateUtils: DateUtilsService,
    private userService: UserService,
    public indexedDbService: IndexedDbService,
    public alertController: AlertController) { }


  dbGetChatMessagesOfUser(userId: number): Promise<ChatMessage[] | null> {
    return new Promise((resolve) => {
      if (this.networkService.isOnline()) {
        let headers = new HttpHeaders({
            'Authorization': this.userService.getHttpHeaders()
        });
        this.http.get<any[]>(environment.API_URL + 'IA/ws_private/' + userId + '/GetChatMessagesOfUser/', {headers : headers}).subscribe(async (response: { [key: string]: any }) => {
          var chatMessages: ChatMessage[] =[]

          for(let b of response['messages']) {
            var chatMessage = this.chatMessages.find(a => a.id == b['id'])
            if(!chatMessage){
              chatMessage = new ChatMessage()
              this.chatMessages.push(chatMessage);
            }

            chatMessage.id = b['id']
            chatMessage.userId = b['userId']
            chatMessage.date = b['date']
            chatMessage.message = b['message']
            chatMessage.response = b['response']

            chatMessages.push(chatMessage);
          }

          resolve(chatMessages);
        },
        () => {
          resolve(this.chatMessages.filter(a => a.userId = userId));
        })
      } else {
        resolve(this.chatMessages.filter(a => a.userId = userId));
      }
    });
  }


  dbSendChatMessage(chatMessage: ChatMessage) {
    return new Promise((resolve, reject) => {
      if (this.networkService.isOnline()) {
        let headers = new HttpHeaders({
            'Authorization': this.userService.getHttpHeaders()
        });
        let formData: { [key: string]: any } = {};
        formData["id"] = chatMessage.id;
        formData["date"] = chatMessage.date;
        formData["message"] = chatMessage.message;

        this.http.post<any[]>(environment.API_URL + 'IA/ws_private/sendChatMessage/', formData, {headers : headers}).subscribe({
          next: (response: { [key: string]: any }) => {
            if (chatMessage.id == null) {
              chatMessage.id = response['id']
            }
            chatMessage.response = response['response']
            resolve(chatMessage);
          },
          error: async (error) => {
            reject(error);
          }
        });
      } else {
        this.indexedDbService.addItem({'obj': chatMessage, 'action': 'save'}).subscribe(() => {});
        resolve(chatMessage)
      }
    });
  }
  
}
